export default __webpack_public_path__ + "static/media/wifi_okay_signal.627c72bf.svg";